import { useEffect, useRef } from 'react';

export const useResizeObserver = (callback: (entry: ResizeObserverEntry) => void) => {
  const targetRef = useRef<HTMLElement | null>(null);
  const observerRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    const cleanup = () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };

    if (targetRef.current) {
      observerRef.current = new ResizeObserver((entries) => {
        if (entries[0]) {
          window.requestAnimationFrame(() => {
            callback(entries[0]);
          });
        }
      });

      observerRef.current.observe(targetRef.current);
    }

    return cleanup;
  }, [callback]);

  return targetRef;
};
